import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel';

const BASE = BaseModel.getApiBasePath() + '/api/v1/mka/detections';

export default new class MkaDetectionsModel {

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, {id: id}));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(parkinglocation = null, dateFrom = null, dateTo = null) {
    var filter = {
      where: {
        and: []
      }
    };
    if (parkinglocation) {      
      filter.where.and.push({parkingLocationId: parkinglocation});
    }    
    if (dateFrom && dateTo) {      
      filter.where.and.push({timestamp: { gte: dateFrom }});
      filter.where.and.push({timestamp: { lte: dateTo }});
    }        
    return new Promise((resolve, reject) => {      
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),   
          filter: filter       
        }
      })
      .then((response) => {        
        ParkinglocationModel.getAll()
        .then((pl) => {
          let data = [];
          response.data.map(async (child, idx) => {             
            let location = _.find(pl, {id: child.parkingLocationId});            
            location 
              ? data.push(Object.assign({}, child, {parkingLocationName: location.Code + ' - ' + location.Name, Status: 2}))
              : data.push(Object.assign({}, child, {parkingLocationName: 'Neznámá lokalita', Status: 2}));        
          });
          resolve(data);          
        });        
      })
      .catch((error) => {
        reject(error);
      });      
    });    
  }

}


// WEBPACK FOOTER //
// ./src/components/MkaDetectionsModel.js